// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: Arial, sans-serif;
}

.download-button, .report-button, .submit-button {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
}

.download-button:hover, .report-button:hover, .submit-button:hover {
  background-color: #45a049;
}

.instructions {
  margin-top: 30px;
  text-align: left;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  max-width: 600px;
  margin: 30px auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.instructions h2 {
  color: #333;
  margin-bottom: 20px;
}

.instructions .step {
  margin-bottom: 20px;
}

.instructions .step h3 {
  color: #555;
  margin-bottom: 10px;
}

.instructions .step p {
  color: #777;
  line-height: 1.6;
}

.report-form {
  margin-top: 30px;
  text-align: left;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
  max-width: 600px;
  margin: 30px auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.report-form h2 {
  color: #333;
  margin-bottom: 20px;
}

.report-form label {
  display: block;
  margin-bottom: 5px;
  color: #555;
}

.report-form textarea {
  width: 100%;
  height: 100px;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

.report-form input[type="file"] {
  margin-bottom: 20px;
}

.report-form .submit-button {
  display: block;
  width: 100%;
  padding: 10px;
}

.image-preview {
  margin-top: 20px;
}

.image-preview img {
  max-width: 100%;
  height: auto;
  border: 1px solid #ccc;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CreateAppFlowC/DownloadAndInstructions.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n  font-family: Arial, sans-serif;\n}\n\n.download-button, .report-button, .submit-button {\n  background-color: #4CAF50;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 20px;\n}\n\n.download-button:hover, .report-button:hover, .submit-button:hover {\n  background-color: #45a049;\n}\n\n.instructions {\n  margin-top: 30px;\n  text-align: left;\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 10px;\n  max-width: 600px;\n  margin: 30px auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.instructions h2 {\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.instructions .step {\n  margin-bottom: 20px;\n}\n\n.instructions .step h3 {\n  color: #555;\n  margin-bottom: 10px;\n}\n\n.instructions .step p {\n  color: #777;\n  line-height: 1.6;\n}\n\n.report-form {\n  margin-top: 30px;\n  text-align: left;\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 10px;\n  max-width: 600px;\n  margin: 30px auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.report-form h2 {\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.report-form label {\n  display: block;\n  margin-bottom: 5px;\n  color: #555;\n}\n\n.report-form textarea {\n  width: 100%;\n  height: 100px;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n.report-form input[type=\"file\"] {\n  margin-bottom: 20px;\n}\n\n.report-form .submit-button {\n  display: block;\n  width: 100%;\n  padding: 10px;\n}\n\n.image-preview {\n  margin-top: 20px;\n}\n\n.image-preview img {\n  max-width: 100%;\n  height: auto;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
